import { useContext, useState } from 'react';
import * as Toast from '../../lib/Toast.js';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { ErrorContext } from '../../lib/ErrorContext';
import usePostApi from '../../lib/usePostApi.js';
import * as ClientApi from '~/lib/ClientApi';

export default function (route) {
    const [isSaving, setIsSaving] = useState(false);
    const { errors, setErrors } = useContext(ErrorContext);

    const { businessId } = useParams();

    function save(data, opts) {
        setErrors(null);
        if (isSaving) {
            // Already saving, don't submit again
            return {
                then: () => null,
                catch: () => null,
                finally: () => null,
            };
        }

        setIsSaving(true);
        return ClientApi.post(route, data)
            .catch(err => {
                const message = err.response?.data?.message;

                if (typeof opts?.onErrorMessage === 'function') {
                    opts.onErrorMessage(message);
                } else {
                    if (message) {
                        Toast.error(message);
                    } else {
                        Toast.error('Failed to save, please try again');
                    }
                }

                if (err.response?.data?.errors) {
                    setErrors(err.response?.data?.errors);
                }
                throw err;
            })
            .then(data => {
                return data;
            })
            .finally(() => {
                setIsSaving(false);
            });
    }

    return {
        isSaving,
        save,
    };
}
